import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { avisoCorrecto, avisoInformativo, avisoError } from "../../components/AvisosMensajes/MensajesSwalf";
import { guardarVoucher, eliminarVoucher } from "../../../actions/pagosActions";
import { updateStateModalLarge } from "../../../actions/modalActions";

const AddNewVoucherModal = ({ onClose, id_dt_matricula_proyecto, tp_cuota, archivosExistentes = [], areaRegistro = null, onVoucherDeleted }) => {
  const dispatch = useDispatch();
  const [experienceFiles, setExperienceFiles] = useState([]);
  const [salesFiles, setSalesFiles] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const usuario = useSelector((state) => state.usuario?.usuario || state.usuario || null);
  let rol = (usuario?.nombre_tp_nivel_usuario?.trim().toUpperCase() || "");
if (rol === "EXPERIENCIA") rol = "EXPCLIENTE";
if (rol === "VENTA") rol = "VENTAS";

  const expInputRef = useRef(null);
  const salesInputRef = useRef(null);

  // Cargar archivos existentes al abrir el modal
  useEffect(() => {
  if (archivosExistentes && archivosExistentes.length > 0 && areaRegistro) {
    const archivosCargados = archivosExistentes.map(archivo => {
      const rutaArchivo = `${process.env.REACT_APP_API_URL}/files_vouchers/${archivo.archivo_voucher}`;
      const esPdf = archivo.archivo_voucher.toLowerCase().endsWith('.pdf');
      return {
        id: archivo.id_registro_pago || archivo.id_registro_pago_voucher || archivo.iid || Date.now(), // ← usar este campo
        name: archivo.archivo_voucher,
        url: rutaArchivo,
        type: esPdf ? 'application/pdf' : 'image/jpeg',
        existente: true,
        id_registro_pago: archivo.id_registro_pago || archivo.id_registro_pago_voucher || archivo.iid // ← asignar aquí
      };
    });
    
    if (areaRegistro === "1") {
      setExperienceFiles(archivosCargados);
    } else if (areaRegistro === "2") {
      setSalesFiles(archivosCargados);
    }
  }
}, [archivosExistentes, areaRegistro,  refreshKey]);

  const handleFiles = (fileList, type) => {
    const filesArray = Array.from(fileList);

    for (const file of filesArray) {
      if (file.size > 5 * 1024 * 1024) {
        avisoInformativo(`El archivo ${file.name} supera los 5MB.`);
        continue;
      }
      if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
        avisoInformativo(`Formato no permitido: ${file.name}. Solo JPG, PNG o PDF.`);
        continue;
      }

      const nuevoArchivo = {
        id: Date.now() + Math.random(),
        file: file,
        name: file.name,
        preview: URL.createObjectURL(file),
        type: file.type,
        size: file.size,
        existente: false
      };

      if (type === "experience") {
        setExperienceFiles(prev => [...prev, nuevoArchivo]);
      } else if (type === "sales") {
        setSalesFiles(prev => [...prev, nuevoArchivo]);
      }
    }
  };

  const handleFileInputChange = (e, type) => {
    handleFiles(e.target.files, type);
    e.target.value = "";
  };

  const handleDrop = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer?.files?.length) {
      handleFiles(e.dataTransfer.files, type);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleRemoveFile = async (type, indexToRemove, item) => {
  

  // quitar de UI
  if (type === "experience") {
    setExperienceFiles(prev => prev.filter((_, i) => i !== indexToRemove));
  } else {
    setSalesFiles(prev => prev.filter((_, i) => i !== indexToRemove));
  }

  if (item && item.id_registro_pago) {
    
    await dispatch(eliminarVoucher(item.id_registro_pago, item.name));
  } else if (item && item.name) {
    
    await dispatch(eliminarVoucher(item.id_registro_pago || item.id || null, item.name));
  }

  avisoCorrecto("Voucher eliminado");
  if (onVoucherDeleted) {
  onVoucherDeleted();
}
};


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!usuario) {
      avisoInformativo("El usuario aún no está cargado. Intenta nuevamente.");
      return;
    }

    if (experienceFiles.length === 0 && salesFiles.length === 0) {
      avisoInformativo("Debes subir al menos un archivo.");
      return;
    }

    const nuevosExperience = experienceFiles.filter(f => !f.existente);
    const nuevosSales = salesFiles.filter(f => !f.existente);

    if (nuevosExperience.length === 0 && nuevosSales.length === 0) {
      avisoInformativo("Debes subir al menos un archivo nuevo.");
      return;
    }

    const promises = [];

    nuevosExperience.forEach(fileObj => {
      const formData = new FormData();
      formData.append("data", JSON.stringify({
        id_dt_matricula_proyecto,
        tipo_voucher: 1,
        id_usuario: usuario.id_usuario || usuario.id,
        tp_cuota
      }));
      formData.append("archivo", fileObj.file);
      promises.push(dispatch(guardarVoucher(formData)));
    });

    nuevosSales.forEach(fileObj => {
      const formData = new FormData();
      formData.append("data", JSON.stringify({
        id_dt_matricula_proyecto,
        tipo_voucher: 2,
        id_usuario: usuario.id_usuario || usuario.id,
        tp_cuota
      }));
      formData.append("archivo", fileObj.file);
      promises.push(dispatch(guardarVoucher(formData)));
    });

    Promise.all(promises).then(() => {
  avisoCorrecto("Todos los vouchers se guardaron correctamente");

  if (onVoucherDeleted) {
    onVoucherDeleted();
  }

  dispatch(updateStateModalLarge());
  if (onClose) onClose();
});
  };

  const renderMiniPestanas = (files, type) => {
    if (!files.length) return null;

    return (
      <div className="mt-3 d-flex flex-wrap gap-2">
        {files.map((item, idx) => {
          const esImagen = item.type?.startsWith("image/") || (item.url && !item.url?.endsWith('.pdf'));
          const srcUrl = item.url || item.preview;
          const nombreArchivo = item.name || (item.url?.split('/').pop() || 'archivo');
          const tamaño = item.size ? `${(item.size / 1024).toFixed(1)} KB` : '';

          return (
            <div key={item.id || idx} className="position-relative" style={{ display: "inline-block" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                {esImagen ? (
                  <img
                    src={srcUrl}
                    className="img-fluid rounded border"
                    style={{ width: "80px", height: "80px", objectFit: "cover", cursor: "pointer" }}
                    alt="voucher"
                    onClick={() => {
                      if (item.url) {
                        window.open(item.url, '_blank');
                      }
                    }}
                  />
                ) : (
                  <div 
                    className="border rounded p-2 text-center bg-light" 
                    style={{ width: "80px", height: "80px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                    onClick={() => {
                      if (item.url) {
                        window.open(item.url, '_blank');
                      }
                    }}
                  >
                    <i className="bi bi-file-earmark-pdf fs-2 text-danger" />
                    <small className="text-muted" style={{ fontSize: "10px" }}>PDF</small>
                  </div>
                )}
                <button
                  type="button"
                  className="border-0"
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "0",
                    width: "24px",
                    height: "24px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    backgroundColor: "#dc3545",
                    color: "white",
                    cursor: "pointer",
                    borderRadius: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  onClick={() => handleRemoveFile(type, idx, item)}
                  title="Eliminar"
                >
                  −
                </button>
              </div>
              {nombreArchivo && <small className="text-muted d-block text-center mt-1" style={{ fontSize: "10px", maxWidth: "80px", overflow: "hidden", textOverflow: "ellipsis" }}>{nombreArchivo}</small>}
              {tamaño && <small className="text-muted d-block text-center" style={{ fontSize: "9px" }}>{tamaño}</small>}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="container-fluid py-2">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-1">
              <i className="bi bi-receipt-cutoff me-2 text-primary" />
              Subir voucher de pago
            </h5>
            <small className="text-muted">
              ID: <span className="fw-bold text-primary">{id_dt_matricula_proyecto}</span>
            </small>
          </div>
          <span className="badge bg-light text-secondary border">
            <i className="bi bi-info-circle me-1" />
            Se pueden subir múltiples vouchers
          </span>
        </div>

        <div className="alert alert-primary py-2 mb-4">
          <div className="d-flex align-items-center">
            <i className="bi bi-shield-check me-2" />
            <div className="small">
              Selecciona o arrastra uno o más vouchers en una de las secciones.
            </div>
          </div>
        </div>

        <div className="row g-3">
          {/* Columna Experiencia */}
          <div className="col-12 col-md-6">
            <div className="card shadow-sm h-100 border-0">
              <div className="card-header d-flex justify-content-between align-items-center py-2 bg-white border-0 border-bottom">
                <div className="d-flex align-items-center gap-2">
                  <span className="avatar rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center">
                    <i className="bi bi-mortarboard text-primary" />
                  </span>
                  <div>
                    <h6 className="mb-0">Voucher de Experiencia</h6>
                    <small className="text-muted">Comprobantes asociados al área de experiencia</small>
                  </div>
                </div>
                {experienceFiles.length > 0 && (
                  <span className="badge bg-success bg-opacity-10 text-success">
                    <i className="bi bi-check-circle me-1" /> {experienceFiles.length} archivo(s)
                  </span>
                )}
              </div>

              <div className="card-body d-flex flex-column">
                {(rol === "EXPCLIENTE" || rol === "OPERACIONES") ? (
                  <div
                    className={`rounded-4 p-3 mb-3 text-center position-relative ${experienceFiles.length > 0 ? "bg-success bg-opacity-10" : "bg-light"}`}
                    style={{
                      border: "2px dashed",
                      borderColor: experienceFiles.length > 0 ? "#19875433" : "#6c757d66",
                      cursor: "pointer",
                      minHeight: "170px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      transition: "all 0.2s ease-in-out",
                    }}
                    onClick={() => expInputRef.current?.click()}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, "experience")}
                  >
                    <div className="mb-2">
                      <i className="bi bi-cloud-arrow-up fs-1" />
                    </div>
                    <p className="mb-1 fw-semibold">Arrastra y suelta los vouchers aquí</p>
                    <small className="text-muted d-block mb-1">o haz clic para seleccionar archivos</small>
                    <small className="text-muted">Formatos permitidos: imágenes (JPG/PNG) o PDF</small>
                    <input
                      ref={expInputRef}
                      type="file"
                      className="d-none"
                      multiple
                      accept="image/*,.pdf"
                      onChange={(e) => handleFileInputChange(e, "experience")}
                    />
                  </div>
                ) : (
                  <div
                    className="rounded-4 p-3 mb-3 text-center bg-light"
                    style={{
                      border: "2px dashed #6c757d66",
                      minHeight: "170px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <div className="mb-2">
                      <i className="bi bi-lock fs-1 text-muted" />
                    </div>
                    <p className="mb-1 fw-semibold text-muted">
                      Solo personal de Experiencia y Operaciones puede subir vouchers
                    </p>
                  </div>
                )}

                {renderMiniPestanas(experienceFiles, "experience")}
              </div>
            </div>
          </div>

          {/* Columna Ventas */}
          <div className="col-12 col-md-6">
            <div className="card shadow-sm h-100 border-0">
              <div className="card-header d-flex justify-content-between align-items-center py-2 bg-white border-0 border-bottom">
                <div className="d-flex align-items-center gap-2">
                  <span className="avatar rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center">
                    <i className="bi bi-cash-stack text-warning" />
                  </span>
                  <div>
                    <h6 className="mb-0">Voucher de Ventas</h6>
                    <small className="text-muted">Comprobantes asociados al área de Ventas</small>
                  </div>
                </div>
                {salesFiles.length > 0 && (
                  <span className="badge bg-success bg-opacity-10 text-success">
                    <i className="bi bi-check-circle me-1" /> {salesFiles.length} archivo(s)
                  </span>
                )}
              </div>

              <div className="card-body d-flex flex-column">
                {(rol === "VENTAS" || rol === "OPERACIONES") ? (
                  <div
                    className={`rounded-4 p-3 mb-3 text-center position-relative ${salesFiles.length > 0 ? "bg-success bg-opacity-10" : "bg-light"}`}
                    style={{
                      border: "2px dashed",
                      borderColor: salesFiles.length > 0 ? "#19875433" : "#6c757d66",
                      cursor: "pointer",
                      minHeight: "170px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      transition: "all 0.2s ease-in-out",
                    }}
                    onClick={() => salesInputRef.current?.click()}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, "sales")}
                  >
                    <div className="mb-2">
                      <i className="bi bi-cloud-arrow-up fs-1" />
                    </div>
                    <p className="mb-1 fw-semibold">Arrastra y suelta los vouchers aquí</p>
                    <small className="text-muted d-block mb-1">o haz clic para seleccionar archivos</small>
                    <small className="text-muted">Formatos permitidos: imágenes (JPG/PNG) o PDF</small>
                    <input
                      ref={salesInputRef}
                      type="file"
                      className="d-none"
                      multiple
                      accept="image/*,.pdf"
                      onChange={(e) => handleFileInputChange(e, "sales")}
                    />
                  </div>
                ) : (
                  <div
                    className="rounded-4 p-3 mb-3 text-center bg-light"
                    style={{
                      border: "2px dashed #6c757d66",
                      minHeight: "170px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <div className="mb-2">
                      <i className="bi bi-lock fs-1 text-muted" />
                    </div>
                    <p className="mb-1 fw-semibold text-muted">
                      Solo personal de Ventas y Operaciones puede subir vouchers
                    </p>
                  </div>
                )}

                {renderMiniPestanas(salesFiles, "sales")}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-2">
          <div className="small text-muted">
            <i className="bi bi-exclamation-circle me-1" />
            Recuerda que los vouchers deben ser legibles y corresponder al registro de pago seleccionado.
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={experienceFiles.length === 0 && salesFiles.length === 0}>
              <i className="bi bi-save me-1" /> Guardar vouchers ({experienceFiles.length + salesFiles.length})
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

AddNewVoucherModal.propTypes = {
  onClose: PropTypes.func,
  id_dt_matricula_proyecto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tp_cuota: PropTypes.any,
  archivosExistentes: PropTypes.array,
  areaRegistro: PropTypes.string,
};

export default AddNewVoucherModal;